
module.exports={
  url:"http://3.108.211.189"  //server url
 //  url:"http://localhost:8086" 
}
